export default __webpack_public_path__ + "static/media/gamestack-list.1b8787ae.jpg";